import moment from 'moment-timezone';

export const formatDuration = (seconds) => {
  if (!seconds) return '00:00:00';
  
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  const pad = (num) => String(num).padStart(2, '0');
  
  return `${pad(hours)}:${pad(minutes)}:${pad(remainingSeconds)}`;
};

export const formatDateTime = (date) => {
  if (!date) return '';
  return moment(date).format('YYYY-MM-DD HH:mm:ss');
};

export const formatDate = (date) => {
  if (!date) return '';
  return moment(date).format('YYYY-MM-DD');
};

export const formatTime = (time) => {
  if (!time) return '';
  return moment(time).format('HH:mm:ss');
}; 